import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './auth-pages.css';

import captCrest    from '../Assets/CAPT_crest.jpg';

export default function SignUpPage({ data }) {
    const navigate = useNavigate();
    const [username, setUsername]               = useState('');
    const [password, setPassword]               = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPw, setShowPw]                   = useState(false);
    const [showConfirm, setShowConfirm]         = useState(false);
    const [errors, setErrors]                   = useState({});
    const [loading, setLoading]                 = useState(false);

    const clearError = (field) => setErrors(prev => ({ ...prev, [field]: '' }));

    // ── original logic, unchanged ──────────────────────────────────────────
    const handleSignUp = async () => {
        const e = {};
        if (!username)         e.username = 'Username is required.';
        if (!password)         e.password = 'Password is required.';
        if (!confirmPassword)  e.confirm  = 'Please confirm your password.';
        else if (password !== confirmPassword) e.confirm = 'Passwords do not match.';
        if (Object.keys(e).length) { setErrors(e); return; }

        setLoading(true);
        try {
            await fetch(process.env.REACT_APP_BACKEND_URL + `/auth/whitelist/?username=${username}`)
                .then(res => res.json())
                .then(result => {
                    if (result.exists) {
                        sessionStorage.setItem('signup_password', password);
                        navigate('/otp', { state: { username, purpose: 'signup' } });
                    } else {
                        throw new Error('Username not whitelisted');
                    }
                });
        } catch (error) {
            console.log('Sign up error: ', error);
            setErrors({ submit: 'User is not whitelisted. Please contact your captain.' });
        } finally {
            setLoading(false);
        }
    };
    // ──────────────────────────────────────────────────────────────────────

    return (
        <div className="ap-page">
            <div className="ap-wrap">

                {/* Brand */}
                <div className="ap-brand">
                    <div className="ap-brand-logo">
                        <div className="ap-logo-icon">
                            <img src={captCrest} alt="CAPT Crest" />
                        </div>
                        <span className="ap-wordmark">NEXUS</span>
                    </div>
                    <span className="ap-brand-sub">Captain Portal · By Tech Comm</span>
                </div>

                {/* Card */}
                <div className="ap-card">
                    <div className="ap-card-accent" />
                    <div className="ap-card-header">
                        <h1 className="ap-card-title">Create an account</h1>
                        <p className="ap-card-subtitle">Your Telegram handle must be whitelisted to sign up</p>
                    </div>

                    <div className="ap-card-body">

                        {/* Username */}
                        <div className="ap-field">
                            <label className="ap-label" htmlFor="su-username">Telegram Username</label>
                            <div className="ap-input-wrap">
                                <svg className="lp-input-icon" viewBox="0 0 16 16" fill="none">
                                    <circle cx="8" cy="5.5" r="2.8" stroke="currentColor" strokeWidth="1.4" />
                                    <path d="M2.5 13.5C2.5 11 5 9 8 9s5.5 2 5.5 4.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                                </svg>
                                <input
                                    id="su-username"
                                    className={`ap-input${errors.username ? ' ap-input--error' : ''}`}
                                    type="text"
                                    placeholder="Enter your Telegram username"
                                    value={username}
                                    autoCapitalize="none"
                                    spellCheck={false}
                                    onChange={e => { setUsername(e.target.value); clearError('username'); }}
                                />
                            </div>
                            {errors.username && <span className="ap-error">{errors.username}</span>}
                        </div>

                        {/* Password */}
                        <div className="ap-field">
                            <label className="ap-label" htmlFor="su-password">Password</label>
                            <div className="ap-input-wrap">
                                <svg className="lp-input-icon" viewBox="0 0 16 16" fill="none">
                                    <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
                                    <path d="M5.5 7V5C5.5 3.6 6.6 2.5 8 2.5S10.5 3.6 10.5 5v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                                    <circle cx="8" cy="10.5" r="1" fill="currentColor" />
                                </svg>
                                <input
                                    id="su-password"
                                    className={`ap-input${errors.password ? ' ap-input--error' : ''}`}
                                    type={showPw ? 'text' : 'password'}
                                    placeholder="Create a password"
                                    value={password}
                                    onChange={e => { setPassword(e.target.value); clearError('password'); }}
                                />
                                <button
                                    type="button"
                                    className="ap-pw-toggle"
                                    onClick={() => setShowPw(v => !v)}
                                    aria-label="Toggle password"
                                >
                                    {showPw ? (
                                        <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><path d="M2 2L14 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M6.5 6.7A2 2 0 0 0 9.3 9.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M4.3 4.5C3 5.3 2 6.6 2 8c0 0 2.5 4 6 4a6 6 0 0 0 3.7-1.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M10.5 5.5A5.9 5.9 0 0 1 14 8c0 0-2.5 4-6 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
                                    ) : (
                                        <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><ellipse cx="8" cy="8" rx="5.5" ry="3.5" stroke="currentColor" strokeWidth="1.4"/><circle cx="8" cy="8" r="1.5" fill="currentColor"/></svg>
                                    )}
                                </button>
                            </div>
                            {errors.password && <span className="ap-error">{errors.password}</span>}
                        </div>

                        {/* Confirm password */}
                        <div className="ap-field">
                            <label className="ap-label" htmlFor="su-confirm">Confirm Password</label>
                            <div className="ap-input-wrap">
                                <svg className="lp-input-icon" viewBox="0 0 16 16" fill="none">
                                    <rect x="3" y="7" width="10" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
                                    <path d="M5.5 7V5C5.5 3.6 6.6 2.5 8 2.5S10.5 3.6 10.5 5v2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                                    <circle cx="8" cy="10.5" r="1" fill="currentColor" />
                                </svg>
                                <input
                                    id="su-confirm"
                                    className={`ap-input${errors.confirm ? ' ap-input--error' : ''}`}
                                    type={showConfirm ? 'text' : 'password'}
                                    placeholder="Re-enter your password"
                                    value={confirmPassword}
                                    onChange={e => { setConfirmPassword(e.target.value); clearError('confirm'); }}
                                    onKeyDown={e => e.key === 'Enter' && handleSignUp()}
                                />
                                <button
                                    type="button"
                                    className="ap-pw-toggle"
                                    onClick={() => setShowConfirm(v => !v)}
                                    aria-label="Toggle confirm password"
                                >
                                    {showConfirm ? (
                                        <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><path d="M2 2L14 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M6.5 6.7A2 2 0 0 0 9.3 9.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M4.3 4.5C3 5.3 2 6.6 2 8c0 0 2.5 4 6 4a6 6 0 0 0 3.7-1.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M10.5 5.5A5.9 5.9 0 0 1 14 8c0 0-2.5 4-6 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
                                    ) : (
                                        <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><ellipse cx="8" cy="8" rx="5.5" ry="3.5" stroke="currentColor" strokeWidth="1.4"/><circle cx="8" cy="8" r="1.5" fill="currentColor"/></svg>
                                    )}
                                </button>
                            </div>
                            {/* Live match indicator */}
                            {confirmPassword && password && (
                                <span className={confirmPassword === password ? 'ap-success-msg' : 'ap-error'}>
                                    {confirmPassword === password ? '✓ Passwords match' : 'Passwords do not match'}
                                </span>
                            )}
                            {errors.confirm && !confirmPassword && <span className="ap-error">{errors.confirm}</span>}
                        </div>

                        {/* Submit error */}
                        {errors.submit && (
                            <div className="ap-banner ap-banner--error" style={{ marginBottom: 16 }}>
                                <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4"/><path d="M8 5v4M8 11v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                                {errors.submit}
                            </div>
                        )}

                        {/* Buttons */}
                        <div className="ap-btn-row" style={{ marginTop: 8 }}>
                            <button className="ap-btn-secondary" onClick={() => navigate('/')}>
                                <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><path d="M6 3H3V13H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 5.5L13 8L10 10.5M13 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                Sign in
                            </button>
                            <button
                                className="ap-btn-primary"
                                onClick={handleSignUp}
                                disabled={loading}
                            >
                                {loading ? <span className="ap-spinner" /> : 'Sign Up'}
                            </button>
                        </div>
                    </div>
                </div>

                <p className="ap-footer-note">
                    Only whitelisted Telegram handles can register. Contact your captain if you need access.
                </p>
            </div>
        </div>
    );
}
